/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { supportGetTicket } from "../../funcs/supportGetTicket.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetTicketRequest$inboundSchema,
};

export const tool$supportGetTicket: ToolDefinition<typeof args> = {
  name: "support-get-ticket",
  description: `Retrieve a support ticket by ID.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/tickets.read\` scope.

If you're retrieving another account's ticket, then you'll need to
specify the \`/accounts/{partnerAccountID}/tickets.read\` and \`/accounts/{accountID}/profile.read\` scopes.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await supportGetTicket(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
